import {
  altColor,
  altColorDarkText,
  altColorLighter,
  mainColor,
  mainColorLighter,
  mainColorMediumText,
} from 'src/ui/theme/tokens'

// Team identities stay orange (1) and blue (2), using the shared A4 palette.
export const getTeamColor = (team: number | undefined): string | undefined =>
  team === 1 ? altColor : team === 2 ? mainColor : undefined
export const getTeamColorLight = (team: number | undefined): string | undefined =>
  team === 1 ? altColorLighter : team === 2 ? mainColorLighter : undefined
export const getTeamColorLighter = getTeamColorLight
export const getTeamColorDark = (team: number | undefined): string | undefined =>
  team === 1 ? altColorDarkText : team === 2 ? mainColorMediumText : undefined
